export * from './checkAnnotationsEnvironmentPrerequisites';